module.exports = __webpack_public_path__ + "media/components/src/assets/images/menu_5-d8ac118b1aef8405d65ac31c09aeb062.jpg";